export default "__VITE_ASSET__F4cLIzas__"